import { Box, MenuItem, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { isAdmin, isDealer, isSuperOperator } from '../services/AccountService'
import { getComp } from '../utils/utils/DI'
import { getValidStatusValues } from '../views/RequestsManagement/components/NewRequestsTable/helpers/getValidStatusValue'
import { RequestsTabType } from '../views/Service/components/AdminTables/stores/AdminServiceTablesStore'

export const requestFilters = {
  year: (intl: any, name?: string) => ({
    type: 'select',
    name: intl.formatMessage({ id: name ?? 'Год' }),
    propName: 'year',
    collection: getYears(2022),
    label: intl.formatMessage({ id: name ?? 'Год' }),
  }),
  installationYear: (intl: any) => ({
    type: 'select',
    name: intl.formatMessage({ id: 'Год установки' }),
    propName: 'installationYear',
    collection: getYears(2022),
    label: intl.formatMessage({ id: 'Год установки' }),
  }),
  territory: (intl: any) => ({
    propName: 'territory',
    name: intl.formatMessage({ id: 'Регион' }),
    type: 'select',
    collection: getComp('TerritoryStore').collection,
    setMenuItem: (el: any) => (
      <MenuItem key={el} value={el}>
        {el}
      </MenuItem>
    ),
  }),
  priorities: (intl: any) => ({
    type: 'select',
    multiple: true,
    propName: 'priorities',
    name: intl.formatMessage({ id: 'Приоритет' }),
    placeholder: intl.formatMessage({ id: 'Приоритет' }),
    collection: getComp('StatusesStore').priorityRequestList,
    setMenuItem: (data: any) => {
      return (
        <MenuItem key={data.key} value={data.value}>
          {data.key}
        </MenuItem>
      )
    },
  }),
  district: (intl: any, filtersStore: any) => ({
    propName: 'district',
    name: intl.formatMessage({ id: 'Округ' }),
    autocompleteOptions: {
      territory: filtersStore.data.territory,
      type: 'district',
    },
    readOnly: filtersStore.data.territory === '',
    disabled: filtersStore.data.territory === '',
    territorySelect: true,
    type: 'autocomplete',
    offError: true,
  }),
  locality: (intl: any, filtersStore: any) => ({
    propName: 'locality',
    name: intl.formatMessage({ id: 'Населённый пункт' }),
    autocompleteOptions: {
      territory: filtersStore.data['territory'],
      district: filtersStore.data['district'],
      type: 'locality',
    },
    readOnly: filtersStore.data.district === '',
    disabled: filtersStore.data.district === '',
    territorySelect: true,
    type: 'autocomplete',
    offError: true,
  }),
  surnamePartial: (intl: any) => ({
    type: 'input',
    propName: 'surnamePartial',
    name: intl.formatMessage({ id: 'Фамилия' }),
  }),
  namePartial: (intl: any) => ({
    type: 'input',
    propName: 'namePartial',
    name: intl.formatMessage({ id: 'Имя' }),
  }),
  phone: (intl: any) => ({
    type: 'input',
    propName: 'phone',
    mask: '+7 (999)-999-99-99',
    name: intl.formatMessage({ id: 'Телефон' }),
  }),
  address: (intl: any, withMarginBottom?: boolean) => ({
    type: 'input',
    propName: 'address',
    name: intl.formatMessage({
      id: 'Регион, МО или ГО, Населённый пункт, Адрес',
    }),
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
    mb: withMarginBottom && 2,
  }),
  fullName: (intl: any) => ({
    type: 'input',
    propName: 'fullName',
    name: intl.formatMessage({ id: 'ФИО' }),
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
  }),
  statuses: (
    intl: any,
    currentPath: string,
    paramsFilterStore: any,
    classes: any,
    tab?: RequestsTabType,
  ) => ({
    type: 'select',
    propName: 'statuses',
    multiple: true,
    name: intl.formatMessage({ id: 'Статуc' }),
    collection: tab
      ? getValidStatusValues(tab, getComp('StatusesStore').getStatusesByRole())
      : getComp('StatusesStore')
          .getStatusesByRole()
          .filter((el: any) =>
            currentPath === '/summary-statistics-dealers' &&
            !paramsFilterStore.statusesPortal.includes('all')
              ? paramsFilterStore.statusesPortal.includes(el.id)
              : true,
          ),

    setMenuItem: (data: any) => (
      <MenuItem value={data.id === 0 ? '' : data.id} key={data.id}>
        <Box className={'aln-center'}>
          <img alt={''} src={data.imageSrc} />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography variant={'subtitle2'} sx={classes.selectText}>
              {data.name}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),

  dataCheckingStatus: (intl: any, dataCheckingStatuses: any[]) => ({
    type: 'select',
    propName: 'dataCheckingStatus',
    name: intl.formatMessage({ id: 'Статус проверки заявок' }),
    placeholder: intl.formatMessage({ id: 'Статус проверки заявок' }),
    collection: dataCheckingStatuses.map((checkingStatus) => {
      return {
        key: checkingStatus.name,
        value: checkingStatus.id,
        color: checkingStatus.color,
      }
    }),
    multiple: true,
  }),
  id: (intl: any) => ({
    type: 'input',
    propName: 'id',
    name: intl.formatMessage({ id: 'Номер заявки' }),
  }),
  orderId: (intl: any) => ({
    type: 'input',
    propName: 'orderId',
    name: intl.formatMessage({ id: 'Номер заявки' }),
  }),
  financialSourceIds: (intl: any, customFilter?: (el: any) => boolean) => ({
    type: 'select',
    multiple: true,
    propName: 'financialSourceIds',
    name: intl.formatMessage({
      id: 'Тип оплаты',
    }),
    placeholder: intl.formatMessage({
      id: 'Тип оплаты',
    }),
    collection: getComp('StatusesStore').financialSources.filter(
      customFilter ?? ((el: any) => (isAdmin() ? el : el.id !== 4)),
    ),
    setMenuItem: (el: any) => {
      return (
        <MenuItem key={el.id} value={el.id === 0 ? '' : el.id}>
          <Box className={'aln-center'}>
            <img alt={''} src={el.imageSrc} />
            <Box ml={1}>
              <Typography variant={'subtitle2'}>{el.name}</Typography>
            </Box>
          </Box>
        </MenuItem>
      )
    },
  }),
  from: (intl: any) => ({
    type: 'date',
    propName: 'from',
    name: intl.formatMessage({ id: 'Период создания с' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
  }),
  to: (intl: any) => ({
    type: 'date',
    propName: 'to',
    name: intl.formatMessage({ id: 'Период создания до' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
  }),
  source: (intl: any) => ({
    type: 'select',
    propName: 'source',
    name: intl.formatMessage({ id: 'Способ добавления' }),
    collection: getComp('SourcesStore').sources,
    setMenuItem: (data: any) => (
      <MenuItem key={data.id} value={data.id}>
        {data.name}
      </MenuItem>
    ),
  }),
  authorId: (intl: any) => ({
    type: 'autocomplete',
    propName: 'authorId',
    name: intl.formatMessage({ id: 'Автор' }),
    collection: getComp('AuthorsStore').authors,
    territorySelect: true,
    autocompleteOptions: {
      territory: '',
      type: 'authorId',
    },
    offError: true,
  }),
  sender: (intl: any, validName?: string) => ({
    type: 'autocomplete',
    propName: validName ?? 'sender',
    name: intl.formatMessage({ id: 'Источник' }),
    territorySelect: true,
    collection: getComp('SendersStore').allSenders,
    autocompleteOptions: {
      territory: '',
      type: 'sender',
    },
    offError: true,
  }),
  senderGroupIds: (intl: any) => ({
    type: 'select',
    propName: 'SenderGroupIds',
    multiple: true,
    name: intl.formatMessage({
      id:
        isAdmin() || isDealer() || isSuperOperator()
          ? 'Группа источников'
          : 'Источник',
    }),
    collection: getComp('StatusesStore').senderGroups,
    setMenuItem: (data: any) => (
      <MenuItem key={data.id} value={data.id}>
        {data.name}
      </MenuItem>
    ),
  }),
  reason: (intl: any) => ({
    type: 'input',
    propName: 'reason',
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
    name: intl.formatMessage({ id: 'Причина' }),
  }),
  reasonId: (intl: any) => ({
    type: 'select',
    propName: 'reasonId',
    name: intl.formatMessage({ id: 'Причина установки' }),
    collection: getComp('InstallationReasonStore').reasons,
    setMenuItem: (data: any) => {
      return <MenuItem value={data.value}>{data.key}</MenuItem>
    },
  }),
  installedFrom: (intl: any, reportMonth: any) => ({
    type: 'date',
    propName: 'installedFrom',
    name: intl.formatMessage({ id: 'Период установки с' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
    defaultMonth: reportMonth ? moment(reportMonth, 'MM') : moment(),
  }),
  installedTo: (intl: any, reportMonth: any) => ({
    type: 'date',
    propName: 'installedTo',
    name: intl.formatMessage({ id: 'Период установки до' }),
    // @ts-ignore
    minDate: moment(window.SAT.config.minDateOperationalSummary)
      .utc()
      .format('YYYY-MM-DD HH:mm'),
    maxDate: moment().utc(true).format('YYYY-MM-DD HH:mm'),
    defaultMonth: reportMonth ? moment(reportMonth, 'MM') : moment(),
  }),
  dealerIds: (intl: any, classes: any, icon: any) => ({
    type: 'select',
    propName: 'dealerIds',
    name: intl.formatMessage({ id: 'Дилер' }),
    multiple: true,
    collection: getComp('DealersStore').collection,
    setMenuItem: (data: any) => (
      <MenuItem value={data.aid} key={data.aid} sx={{ padding: '10px 12px' }}>
        <Box className={'aln-center'} height={20}>
          <img alt={''} src={icon} height={20} width={20} />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography
              variant={'body2'}
              sx={{
                ...classes.selectTextContainer,
                ...classes.selectText,
              }}
            >
              {data.displayName}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  equipmentId: (intl: any) => ({
    type: 'input',
    propName: 'equipmentId',
    name: intl.formatMessage({ id: 'Id оборудования' }),
  }),
  reportId: (intl: any) => ({
    type: 'input',
    propName: 'reportId',
    name: intl.formatMessage({ id: 'Номер отчета' }),
    onlyNumbers: true,
  }),
  agreementCheckingStatus: (intl: any, classes: any) => ({
    type: 'select',
    propName: 'agreementCheckingStatus',
    name: intl.formatMessage({ id: 'Статус проверки договора' }),
    placeholder: intl.formatMessage({ id: 'Статус проверки договора' }),
    collection: getComp('StatusesStore').agreementCheckingStatuses,
    multiple: true,
    setMenuItem: (data: any) => (
      <MenuItem value={data.id} key={data.id}>
        <Box className={'aln-center'}>
          <img alt={''} src={data.imageSrc} />
          <Box ml={1} sx={classes.selectTextContainer}>
            <Typography variant={'subtitle2'} sx={classes.selectText}>
              {data.name}
            </Typography>
          </Box>
        </Box>
      </MenuItem>
    ),
  }),
  preferentialCategory: (intl: any) => ({
    type: 'input',
    propName: 'preferentialCategory',
    name: intl.formatMessage({ id: 'Льготная категория' }),
    placeholder: intl.formatMessage({ id: 'Минимум 3 символа' }),
  }),
  categories: (intl: any) => ({
    type: 'select',
    propName: 'categories',
    name: intl.formatMessage({ id: 'Льготные категории' }),
    placeholder: intl.formatMessage({ id: 'Льготные категории' }),
    collection: getComp('CategoriesStore').categoriesMenuData,
    multiple: true,
  }),
  hasDuplicates: (intl: any) => ({
    type: 'checkbox',
    propName: 'hasDuplicates',
    name: intl.formatMessage({ id: 'Повторное обращение' }),
    visible: true,
    containerStyles: { background: 'white' },
  }),
  isExpired: (intl: any, icon: any) => ({
    type: 'checkbox',
    propName: 'isExpired',
    name: intl.formatMessage({ id: 'Просроченные заявки' }),
    visible: true,
    containerStyles: { background: 'white' },
    icon: <img src={icon} style={{ marginRight: '4px' }} alt='' />,
  }),
  isSuspicious: (intl: any, icon: any) => ({
    type: 'checkbox',
    propName: 'isSuspicious',
    name: intl.formatMessage({ id: 'Отмеченные как подозрительные' }),
    visible: true,
    containerStyles: { background: 'white' },
    icon: <img src={icon} style={{ marginRight: '4px' }} alt='' />,
  }),
  isDangerous: (intl: any) => ({
    type: 'select',
    propName: 'isDangerous',
    name: intl.formatMessage({ id: 'Установки в проблемных зонах' }),
    collection: [
      'Исключить заявки в проблемных зонах',
      'Включить заявки в проблемных зонах',
    ],
    setMenuItem: (data: string) => (
      <MenuItem key={data} value={data}>
        {data}
      </MenuItem>
    ),
  }),
}

function getYears(startYear = 2022): string[] {
  const currentYear = new Date().getFullYear()
  const lastYear = Math.max(currentYear, startYear)
  const years: string[] = []
  for (let y = startYear; y <= lastYear; y++) {
    years.push(String(y))
  }
  return years
}
